import { all, call, put, takeLatest } from "redux-saga/effects";
import { normalize, schema } from "normalizr";
import { toast } from "react-toastify";
import queryString from "query-string";
import { getErrorMessage } from "utils/sagasErrorHandler";
import { ITEMS_PER_PAGE } from "constants/general";
import messageHelper from "utils/messages/messageHelper";
import { sharedHistory } from "routes/sharedHistory";
import { ROUTES_MAP } from "routes/constants";
import {
    getBrandByCode,
    getBrandByCodeError,
    getBrandByCodeSuccess,
    getBrands,
    getBrandsError,
    getBrandsSuccess,
    updateBrand,
    updateBrandError,
    updateBrandSuccess,
    deleteBrand,
    setSelectedBrands,
    createBrandSuccess,
    createBrandError,
    createBrand,
} from "modules/Brands/services/Brands/actions";
import {
    getBrandByCodeRequest,
    getBrandsRequest,
    updateBrandRequest,
    deleteBrandRequest,
    createBrandRequest,
} from "modules/Brands/services/Brands/api";

const brandsSchema = new schema.Entity("brands" , {},{ idAttribute: "code" });
const brandsListSchema = new schema.Array(brandsSchema);

//Workers
function* handleRefreshBrands() {
    const { search } = window.location;
    yield put(setSelectedBrands([]));
    yield put(getBrands({ limit: ITEMS_PER_PAGE, ...queryString.parse(search) }));
}

function* handleGetBrands ({ payload }) {
    try {
        const { brands, count } = yield call(getBrandsRequest, payload);
        const { result, entities } = normalize(brands, brandsListSchema);

        yield put(getBrandsSuccess({
            brands: JSON.stringify(entities) === JSON.stringify({}) ? [] : entities.brands,
            codes: result,
            count
        }));
    } catch (error) {
        yield put(getBrandsError());
        getErrorMessage(error);
    }
}

function* handleGetBrandByCode ({ payload }) {
    try {
        const brand = yield call(getBrandByCodeRequest, payload);
        yield put(getBrandByCodeSuccess(brand));
    } catch (error) {
        yield put(getBrandByCodeError());
        getErrorMessage(error);
    }
}

function* handleUpdateBrand ({ payload }) {
    try {
        yield call(updateBrandRequest, payload);
        yield call(toast.success, `The brand with code - ${payload.code} has been successfully updated`);
        sharedHistory.push(ROUTES_MAP.brands.path);
        yield put(updateBrandSuccess());
    } catch (error) {
        yield put(updateBrandError());
        getErrorMessage(error);
    }
}

function* handleDeleteBrand ({ payload }) {
    try {
        yield all(payload.map((payload) => call(deleteBrandRequest, payload)));
        yield handleRefreshBrands();
        messageHelper({
            type: "success",
            actionSubject: `Brand${payload.length > 1 ? "s" : ""} with id${payload.length > 1 ? "s" : ""} - ${payload.join(", ")}`,
            action: "deleted",
            plural: payload.length > 1
        });
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleCreateBrand ({ payload }) {
    try {
        yield call(createBrandRequest, payload);
        yield put(createBrandSuccess());
        yield call(toast.success, "The brand has been successfully created");
        sharedHistory.push(ROUTES_MAP.brands.path);
    } catch (error) {
        yield put(createBrandError());
        getErrorMessage(error);
    }
}

// Watchers
export function* brandsEntriesSagas() {
    yield all([
        yield takeLatest(getBrands, handleGetBrands),
        yield takeLatest(createBrand, handleCreateBrand),
        yield takeLatest(getBrandByCode, handleGetBrandByCode),
        yield takeLatest(updateBrand, handleUpdateBrand),
        yield takeLatest(deleteBrand, handleDeleteBrand),
    ]);
}
